
import { FunnelsServices } from "@/services";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      locationId: "",
      restoreInProgress: false,
      msg: "",
      errMsg: ""
    };
  },
  methods: {
    async restoreAll() {
      try {
        if (!this.locationId) {
          throw new Error("locationId is required");
        }
        this.msg = "";
        this.errMsg = "";
        this.restoreInProgress = true;
        await FunnelsServices.restoreFunnelsByLocation({
          locationId: this.locationId
        });
        this.msg = "Restore completed";
        this.restoreInProgress = false;
      } catch (error: any) {
        console.error(error);
        if (error && error.request) this.errMsg = JSON.parse(error.request.response).message;
        this.restoreInProgress = false;
      }
    }
  }
});
